import FacebookIcon from '@/assets/icons/facebook_wb.svg?react';
import InstagramIcon from '@/assets/icons/instagram_wb.svg?react';
import TikTokIcon from '@/assets/icons/tik-tok_wb.svg?react';
import {APP_ROUTES} from '@/utils_legacy/routes';

export const LOGIN_FOOTER_GROUP = [
  {
    title: 'Terms of Service',
    link: APP_ROUTES.TermsOfServiceGroup,
  },
  {
    title: 'Privacy Policy',
    link: APP_ROUTES.PrivacyPolicyGroup,
  },
  {
    title: 'Cookie Policy',
    link: APP_ROUTES.CookiePolicy,
  },
  {
    title: 'Community Guidelines',
    link: APP_ROUTES.CommunityGuidelines,
  },
  {
    title: 'Ambassador Public Agreement',
    link: APP_ROUTES.AmbassadorAgreement,
  },
];

export const LOGIN_FOOTER_INC = [
  {
    title: 'Terms of Service',
    link: APP_ROUTES.TermsOfServiceInc,
  },
  {
    title: 'Privacy Policy',
    link: APP_ROUTES.PrivacyPolicyInc,
  },
  {
    title: 'Cookie Policy',
    link: APP_ROUTES.CookiePolicy,
  },
  {
    title: 'Community Guidelines',
    link: APP_ROUTES.CommunityGuidelines,
  },
  {
    title: 'Ambassador Public Agreement',
    link: APP_ROUTES.AmbassadorAgreement,
  },
];

export const LOGIN_FOOTER_ICONS = [
  {
    icon: FacebookIcon,
    link: 'https://www.facebook.com/bumpy.inc/',
  },
  {
    icon: InstagramIcon,
    link: 'https://www.instagram.com/bumpy.app',
  },
  {
    icon: TikTokIcon,
    link: 'https://www.tiktok.com/@bumpy.app',
  },
];
